(() => {
  'use strict';

  const ROOT_SELECTOR = '[data-jm-rc-brands-directory]';

  const normalize = (value) => {
    let normalized = String(value || '').toLowerCase();

    if (typeof normalized.normalize === 'function') {
      normalized = normalized.normalize('NFKD').replace(/[\u0300-\u036f]/g, '');
    }

    return normalized
      .replace(/&/g, ' and ')
      .replace(/[^a-z0-9]+/g, ' ')
      .trim();
  };

  const initializeDirectory = (root) => {
    if (!(root instanceof HTMLElement) || root.dataset.jmRcBrandsInitialized === 'true') {
      return;
    }

    const form = root.querySelector('[data-jm-rc-brands-search-form]');
    const input = root.querySelector('[data-jm-rc-brands-search-input]');
    const clearButton = root.querySelector('[data-jm-rc-brands-clear]');
    const status = root.querySelector('[data-jm-rc-brands-status]');
    const azNavigation = root.querySelector('[data-jm-rc-brands-az]');
    const emptyState = root.querySelector('[data-jm-rc-brands-empty]');
    const cards = Array.from(root.querySelectorAll('[data-jm-rc-brand-card]'));
    const groups = Array.from(root.querySelectorAll('[data-jm-rc-brands-group]'));

    if (!form || !input || !status || cards.length === 0) {
      return;
    }

    const cardSearchValues = new Map(
      cards.map((card) => {
        const spaced = normalize(
          card.getAttribute('data-jm-rc-brand-name') || card.textContent
        );

        return [
          card,
          {
            spaced,
            compact: spaced.replace(/\s+/g, ''),
          },
        ];
      })
    );

    const updateGroupVisibility = () => {
      groups.forEach((group) => {
        const hasVisibleCard = Array.from(
          group.querySelectorAll('[data-jm-rc-brand-card]')
        ).some((card) => !card.hidden);

        group.hidden = !hasVisibleCard;
      });
    };

    const applyFilter = ({ focusFirstMatch = false } = {}) => {
      const query = normalize(input.value);
      const compactQuery = query.replace(/\s+/g, '');
      let matchCount = 0;
      let firstMatch = null;

      cards.forEach((card) => {
        const searchValue = cardSearchValues.get(card);
        const isMatch =
          query === '' ||
          searchValue.spaced.includes(query) ||
          searchValue.compact.includes(compactQuery);
        card.hidden = !isMatch;

        if (isMatch) {
          matchCount += 1;
          if (!firstMatch) {
            firstMatch = card;
          }
        }
      });

      updateGroupVisibility();

      if (azNavigation) {
        azNavigation.hidden = query !== '';
      }

      if (clearButton) {
        clearButton.hidden = query === '';
      }

      if (emptyState) {
        emptyState.hidden = matchCount !== 0;
      }

      if (query === '') {
        status.textContent = 'Browse the complete supported RC brand directory below.';
      } else if (matchCount === 1) {
        status.textContent = '1 matching RC brand.';
      } else if (matchCount > 1) {
        status.textContent = `${matchCount} matching RC brands.`;
      } else {
        status.textContent = 'No matching RC brands.';
      }

      if (focusFirstMatch && firstMatch instanceof HTMLElement) {
        firstMatch.focus();
      }
    };

    form.addEventListener('submit', (event) => {
      event.preventDefault();
      applyFilter({ focusFirstMatch: true });
    });

    input.addEventListener('input', () => {
      applyFilter();
    });

    if (clearButton) {
      clearButton.addEventListener('click', () => {
        input.value = '';
        applyFilter();
        input.focus();
      });
    }

    root.dataset.jmRcBrandsInitialized = 'true';
  };

  document.querySelectorAll(ROOT_SELECTOR).forEach(initializeDirectory);
})();
